import React, { useState } from "react";
import { Tabs } from "antd";
import { LockOutlined } from "@ant-design/icons";
import LayoutOperation from "../../components/layout_operation";
import ChangePass from "../../ui/setting/change_password";
import Api from "../../services/ServiceApi";

const { TabPane } = Tabs;

const UserProfile = () => {
  return (
    <LayoutOperation active={7}>
      <div className="wrapper-header d-flex align-items-center">
        <div className="container-fluid">
          <div className="d-flex align-items-center">
            <img
              src={Api.absoluteUrl("/icon/setting_white.svg")}
              className="mr-3"
              alt=""
            />
            <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b font20">
              {"Profile"}
            </h2>
          </div>
        </div>
      </div>
      <div className="wrapper-body">
        <div className="container-fluid">
          <div className="card-table-ma">
            <Tabs
              defaultActiveKey="1"
              tabPosition="left"
              //   onChange={(key) => this.onSelectTab(key)}
            >
              <TabPane
                tab={
                  <div className="d-flex" style={{ width: 180 }}>
                    <LockOutlined />
                    <div>
                      <h6>Security</h6>
                      <span
                        className="font-mont-r font10"
                        style={{ color: "#98A9BC" }}
                      >
                        Password
                      </span>
                    </div>
                  </div>
                }
                key="1"
              >
                <ChangePass />
              </TabPane>
              {/* <TabPane
                tab={
                  <div className="d-flex" style={{ width: 180 }}>
                    <LockOutlined />
                    <div>
                      <h6>Security</h6>
                      <span
                        className="font-mont-r font10"
                        style={{ color: "#98A9BC" }}
                      >
                        Password
                      </span>
                    </div>
                  </div>
                }
                key="2"
              >
                <ChangePass />
              </TabPane> */}
            </Tabs>
          </div>
        </div>
      </div>
    </LayoutOperation>
  );
};

export default UserProfile;
